import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/profile/actionTypes';
import { updateAvatarPhoto } from './utils';

export default function* listenUploadPhotoSuccess() {
  yield takeEvery(actionTypes.UPLOAD_PHOTO_SUCCESS, updateAvatarPhoto);
}
